// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__THB7R","container":"CardGroup_container__v74ZC"};